(function () {
  if (window.__majaCartPromoTimer) return;
  window.__majaCartPromoTimer = true;

  var STORAGE_KEY = 'maja_cart_reserved_until';
  var DURATION_MS = 7 * 60 * 1000; // 7-minute reservation window, set once per browsing session

  var memoryExpiry = null;

  function getExpiry() {
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      var expiry = stored ? parseInt(stored, 10) : NaN;
      if (!expiry || isNaN(expiry)) {
        expiry = Date.now() + DURATION_MS;
        sessionStorage.setItem(STORAGE_KEY, String(expiry));
      }
      return expiry;
    } catch (e) {
      // Storage unavailable (private mode etc.) — keep a single in-memory
      // expiry for the lifetime of the page so the timer still counts down.
      if (!memoryExpiry) memoryExpiry = Date.now() + DURATION_MS;
      return memoryExpiry;
    }
  }

  var expiry = getExpiry();

  function format(totalSeconds) {
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function tick() {
    // cart-drawer.js replaces #CartDrawer's innerHTML on every add/remove/qty
    // change, so the timer element is a brand-new DOM node after each update.
    // Re-querying it every tick (instead of caching a reference) means this
    // single interval keeps working seamlessly across every re-render.
    var el = document.querySelector('[data-maja-cart-timer]');
    if (!el) return;
    var remainingMs = expiry - Date.now();
    el.textContent = remainingMs > 0 ? format(Math.floor(remainingMs / 1000)) : '00:00';
  }

  tick();
  setInterval(tick, 1000);
})();

